import API from '../../shared/constants/api.const';
import backendApi from '../base.config';

export const authApi = backendApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: API.AUTH.LOGIN,
        method: 'POST',
        body: credentials,
      }),
      extraOptions: {
        mock: false,
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: API.AUTH.LOGOUT,
        method: 'POST',
      }),
      extraOptions: {
        mock: false,
      },
    }),

    forgotPassword: builder.mutation({
      query: (params) => ({
        url: API.AUTH.FORGET_PASSWORD,
        method: 'POST',
        params,
      }),
      extraOptions: {
        mock: true,
      },
    }),

    updatePassword: builder.mutation({
      query: (payload) => ({
        url: API.AUTH.POST_UPDATE_PASSWORD,
        method: 'POST',
        body: payload,
      }),
      extraOptions: {
        mock: false,
      },
    }),
    resetPassword: builder.mutation({
      query: (payload) => ({
        url: API.AUTH.POST_RESET_PASSWORD,
        method: 'POST',
        body: payload,
      }),
      extraOptions: {
        mock: false,
      },
    }),

    getNavigation: builder.mutation({
      query: () => ({
        url: API.USER.GET_NAVIGATION,
        method: 'POST',
      }),
      extraOptions: {
        mock: false,
      },
    }),

    getDomainConfig: builder.query({
      query: () => ({
        url: API.AUTH.GET_DOMAIN_CONFIG,
        method: 'GET',
      }),
      extraOptions: {
        mock: false,
        ignoreHeaders: true,
      },
    }),

    updateTheme: builder.mutation({
      query: (payload) => ({
        url: API.AUTH.UPDATE_THEME,
        method: 'POST',
        body: payload,
      }),
      extraOptions: {
        mock: false,
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useUpdatePasswordMutation,
  useResetPasswordMutation,
  useGetNavigationMutation,
  useLazyGetDomainConfigQuery,
  useUpdateThemeMutation,
} = authApi;
